import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Card from "../../../MyUI/Card/Card";
import EditableForm from "../../../MyUI/EditableForm/EditableForm";
import { forgottenPassword_reset, forgottenPassword_reset_verify } from "../../../../services/services";

export default function ForgottenPasswordResetVerify() {
  const { token } = useParams();

  const formFields = [
    { key: "password", label: "New Password", type: "password", validation: ["required"] },
    { key: "password2", label: "Confirm Password", type: "password", validation: ["required"] },
  ];

  const [formParams, setFormParams] = useState([{}]);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState(""); // "true" | "false" | "saved"
  const [loading, setLoading] = useState(true);

  const idField = "id";
  const services= {
    create: forgottenPassword_reset,
    services_url_names: {
    create: "forgottenPassword_reset",
    },
  }
  
  // CHECK LINK ON MOUNT
  useEffect(() => {
    const resetPassword = async () => {
      setLoading(true);
      try {
        const res = await forgottenPassword_reset_verify(token);
        setMessage("true");
      } catch (err) {
        console.error(err);
        setMessage("false");
      } finally {
        setLoading(false);
      }
    };

    resetPassword();
  }, [token]);


  // RENDER
  if (loading) {
    return (
      <Card title="Reset Password" showChevron={false}>
        <div style={{ textAlign: "center" }}>Loading...</div>
      </Card>
    );
  }

  return (
    <Card title="Reset Password" showChevron={false}>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* LINK VALID */}
        {message === "true" && (
          <>
            <h2 className="important">Reset Password</h2>

            <EditableForm
              params={formParams}
              setParams={setFormParams}
              state="create"
              title="ForgottenPassword_reset"
              columns={formFields}
              saveButtonName={isSaving ? "Saving..." : "Save"}
              services={services}       
              idField={idField}         
              refParam={token}   
              onClose={() => {
                window.location.href = "/ConnectionPopUp";
              }}
              onSaved={(f) => {setMessage(f.message)}}
            />
          </>
        )}
        
        {/* LINK EXPIRED */}
        {message === "false" && (
          <div style={{ color: "red", fontWeight: "bold" }}>
            Link expired !
          </div>
        )}

        {/* PASSWORD SAVED */}
        {message === "saved" && (
          <Link to="/ConnectionPopUp" className="nav-link">
            <button className="label-btn" style={{ "--label-btn-color": "#43A047" }}>
              Password saved! Connect again!
            </button>
          </Link>
        )}
      </div>
    </Card>
  );
}
